import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getHeaderSearchDriverAgeFilter } from '@/redux/selectors/globalHeader';

import { FilterButton } from './FilterButton';

type TDriverAgeFilterButtonProps = {
  toggleFilter: () => void;
  className?: string;
};

export const DriverAgeFilterButton = ({ toggleFilter, className }: TDriverAgeFilterButtonProps) => {
  const intl = useIntl();

  const driverAge = useSelector(getHeaderSearchDriverAgeFilter);

  const getDisplayText = () => {
    if (driverAge === 21) {
      return '21-24';
    }
    if (driverAge === 25) {
      return '25+';
    }
    return intl.formatMessage({
      defaultMessage: 'Add age',
      id: '3pFXWq',
      description: 'Home Search Widget > Driver Age Filter Placeholder',
    });
  };

  return (
    <FilterButton
      aria-label={intl.formatMessage(
        {
          defaultMessage: 'Click to {hasValue, select, true {change the} other {add}} driver age',
          id: '7AOrjX',
          description: 'Home Search Widget > Driver Age Filter Aria Label',
        },
        {
          hasValue: !!driverAge,
        },
      )}
      label={intl.formatMessage({
        defaultMessage: "Driver's age",
        id: 'YZGck7',
        description: 'Home Search Widget > Driver Age Filter Label',
      })}
      value={getDisplayText()}
      onClick={toggleFilter}
      className={className}
    />
  );
};
